module.exports = __webpack_public_path__ + "b8a089ce5c4980ac3d84ce8d4bb836eb.png";